import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderInfo, PaymentEntity } from 'src/app/shared';

const html2canvas = require('html2canvas');

@Component({
  selector: 'app-payment-order-factor',
  templateUrl: './payment-order-factor.component.html',
  styleUrls: ['./payment-order-factor.component.scss'],
})
export class PaymentOrderFactorComponent {
  public info: OrderInfo;
  public index: number;
  public totalOrders: number;
  public payment: PaymentEntity;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    DData: {
      payment: PaymentEntity;
      orderInfo: OrderInfo;
      index: number;
      total: number;
    }
  ) {
    this.index = DData.index;
    this.info = DData.orderInfo;
    this.totalOrders = DData.total;
    this.payment = DData.payment;
  }

  public getDate() {
    return new Date(this.info.instance.createdAt!);
  }

  public download() {
    html2canvas(document.querySelector('#factor'), {
      letterRendering: true,
    }).then((canvas: any) => {
      this.saveAs(
        canvas.toDataURL(),
        [
          'order',
          this.info.instance.id,
          new Date().toUTCString().toString(),
          'factor.png',
        ].join('-')
      );
    });
  }

  public print() {
    html2canvas(document.querySelector('#factor'), {
      letterRendering: true,
    }).then((canvas: any) => {
      var nWindow = window.open('')!;

      // append the canvas to the body
      nWindow.document.body.appendChild(canvas);

      // focus on the window
      nWindow.focus();

      // print the window
      nWindow.print();
    });
  }

  public saveAs(uri: any, filename: string) {
    var link = document.createElement('a');
    if (typeof link.download === 'string') {
      link.href = uri;
      link.download = filename;

      link.style.display = 'none !important';
      link.style.position = 'fixed';
      link.style.bottom = '-100px';

      //Firefox requires the link to be in the body
      document.body.appendChild(link);

      //simulate click
      link.click();

      //remove the link when done
      document.body.removeChild(link);
    } else {
      window.open(uri);
    }
  }
}
